import { Form, Select } from 'antd';

type Option = {
  label: string;
  value: string | number;
  subtext?: string;
};

type DropdownConfig = {
  name: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  options: Option[];
  isDisabled?: (value: string | number) => boolean;
};

const DropdownField = ({ config }: { config: DropdownConfig }) => (
  <Form.Item
    key={config.name}
    name={config.name}
    label={config.label}
    rules={
      config.required
        ? [{ required: true, message: `Please select ${config.label.toLowerCase()}` }]
        : undefined
    }
  >
    <Select 
      placeholder={config.placeholder}
      optionLabelProp="label"
    >
      {config.options.map((option) => (
        <Select.Option
          key={option.value}
          value={option.value}
          label={option.label}
          disabled={config.isDisabled?.(option.value) || false}
        >
          {option.subtext ? (
            <div>
              <div>{option.label}</div>
              <div style={{ fontSize: '12px', color: '#999' }}>{option.subtext}</div>
            </div>
          ) : (
            option.label
          )}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default DropdownField;
